'use es6';

import { createSelector } from 'reselect';
import ContentRoutes from 'ContentUtils/Routes';
import { getScopes } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getPostSettingsFullUrl } from './postSettingsSelectors';
import { getMasterBlogId } from './blogSelectors';
export const getDashboardUrl = createSelector([getCategoryId, getMasterBlogId, getScopes], (categoryId, blogId, scopes) => ContentRoutes.dashboard(categoryId, null, blogId, scopes));
export const getShareablePreviewUrl = createSelector([getContentModelId, getPreviewKey, getPostSettingsFullUrl], (id, previewKey, publishedURL) => {
  return `${publishedURL}?hs_preview=${previewKey}-${id}`;
});